export default __webpack_public_path__ + "static/media/step1_spam_gmail.7ec134bc.png";